/**
import {t, Trans} from '@lingui/macro';
import {withI18n, useLingui} from "@lingui/react";
* Shows how you can use CSS to style your Element's container.
* These classes are added to your Stripe Element by default.
* You can override these classNames by using the options passed
* to the CardElement component.
* https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options-classes
*/
import styled from 'styled-components';

const Styled = styled.div`
    margin-bottom: 16px; 

    h3.title {
        padding-bottom: 4px;
        font-size: 12px;
        font-weight: normal;
        text-transform: uppercase;
    }

    .stripe-logo {
        margin-top: 12px;
        text-align: center;

        img {
            width: 80px;
        }
    }

    .StripeElement {
        width: 100%;
        height: 40px;
        padding: 10px 12px;
        color: #32325d;
        background-color: white;
        border: 1px solid transparent;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        transition: box-shadow 150ms ease;
    }

    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
`;

export default Styled;
